<template>
    <div class="panel-body">
        <div class="user-pc-builds m-l m-t">
            <div class="builds-tables">
                <div class="table-responsive">
                    <div id="no-more-tables">
                        <template v-if="savedBuilds.data.length && !loadingBuilds">
                            <div v-for="(build, index) in savedBuilds.data" :key="index">
                                <div class="order-wrapper clearfix text-white">
                                    <div class="col-md-8 col-xs-5 order-number">
                                        <div class="col-md-12 col-xs-12 order-number p-a-0">
                                            {{ build.bld_number }}
                                        </div>
                                        <div class="col-md-5 col-xs-12 order-number-date p-a-0">
                                            {{ build.created_at | humanizeDate }}
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-xs-7 text-center">
                                        <router-link
                                            :to="{ path: buildUrl(build.bld_number) }"
                                            class="btn btn-sm btn-green btn-round"
                                        >
                                            Build This
                                            <i class="fa fa-long-arrow-right" />
                                        </router-link>
                                        <button
                                            @click="deleteBuild(build.bld_number)"
                                            class="delete-build text-green"
                                        >
                                            <i class="fa fa-times" />
                                        </button>
                                    </div>
                                </div>
                                <table class="table table-no-border text-white">
                                    <thead class="text-grey">
                                        <tr>
                                            <th>Part</th>
                                            <th class="text-a-right">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(part, partIndex) in build.details">
                                            <tr :key="partIndex">
                                                <td>
                                                    {{ part.product_name }}
                                                    <template v-if="part.product_modules_id == 10">
                                                        <small>(max speed)</small>
                                                        <span v-html="getRamSlotsFromText(part.capacity, part.quantity)" />
                                                    </template>
                                                    <template v-else>
                                                        {{ part.capacity }}
                                                    </template>
                                                </td>
                                                <td v-if="+part.price && ![6, 12].includes(+part.product_modules_id)" class="text-a-right">
                                                    {{ part.price }}
                                                </td>
                                                <td v-else class="text-a-right">
                                                    &mdash;
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="savedBuilds.data.length && savedBuilds.total_pages > 1" class="builds-pagination rev-pagination m-t-md">
                                <a disabled="" class="text-green pag-arrow ">
                                    <i
                                        class="fa fa-chevron-left"
                                        :class="{'builds_pagination__arrow_disabled' : page == 1}"
                                        @click="changePage(-1)"
                                    />
                                </a>
                                <div class="pag-text">
                                    <p class="first-number">{{ page }}</p>
                                    <p>of</p>
                                    <p class="last-number">{{ savedBuilds.total_pages }}</p>
                                </div>
                                <a class="text-green pag-arrow">
                                    <i
                                        :class="{'builds_pagination__arrow_disabled' : page == savedBuilds.total_pages}"
                                        class="fa fa-chevron-right"
                                        @click="changePage(1)"
                                    />
                                </a>
                            </div>
                        </template>
                        <template v-if="loadingBuilds">
                            <div style="text-align:center">
                                <span class="fa fa-spin fa-spinner" />
                            </div>
                        </template>
                        <template v-if="!savedBuilds.data.length && !loadingBuilds">
                            <div class="text-center">
                                <h4 class="text-white m-b-md">
                                    You have not made a build from LETSBLD.com yet!
                                </h4>
                                <router-link class="btn btn-sm btn-round btn-green" to="/bld">GO TO BLD
                                    <i class="fa fa-long-arrow-right" />
                                </router-link>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isMobile } from "@u/helpers";
import { getRamSlotsFromText } from "@u/store-helpers";

export default {
    name: "SavedBuilds",
    data() {
        return {
            savedBuilds: {
                data: []
            },
            selectedBuild: {},
            loadingBuilds: true,
            page: 1
        };
    },
    watch: {
        page() {
            this.getBuilds();
        }
    },
    created() {
        this.getBuilds();
    },
    methods: {
        getRamSlotsFromText,
        deleteBuild(buildId) {
            if (confirm("Are you sure you want to delete this saved build?")) {
                axios({
                    url: `drafts/${buildId}`,
                    method: "DELETE"
                }).then(() => {
                    this.page = 1;
                    this.getBuilds();
                });
            }
        },
        getBuilds() {
            this.loadingBuilds = true;
            axios(`/users/0/letsbld-drafts?page=${this.page}&limit=5`).then(builds => {
                this.savedBuilds = builds.data;
            }).finally(() => {
                this.loadingBuilds = false;
            })
        },
        changePage(direction) {
            if (!this.loadingBuilds) {
                this.page = this.page + direction;
                if (this.page < 1) {
                    this.page = 1;
                } else if (this.page > this.savedBuilds.total_pages) {
                    this.page = this.savedBuilds.total_pages;
                }
            }
        },
        buildUrl(buildNumer) {
            const path = isMobile() ? 'step4-mobile' : 'step4';
            return `/bld/${path}?price=1000&draft=${buildNumer}`;
        }
    }
};
</script>
